var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Flex from "@irati/ui/src/Flex";
import { PlaceholderSquare } from "./";
var PlaceholderGrid = /** @class */ (function (_super) {
    __extends(PlaceholderGrid, _super);
    function PlaceholderGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlaceholderGrid.prototype.render = function () {
        var _a = this.props, columns = _a.columns, rows = _a.rows;
        var rowArray = new Array(rows).fill("placholderRow");
        var colArray = new Array(columns).fill("placholderCol");
        var colWidth = 90 / columns + "%";
        return (React.createElement(React.Fragment, null, rowArray.map(function (rowLabel, rowIndex) { return (React.createElement(Flex, { justifyContent: "space-between", key: rowLabel + "#" + rowIndex }, colArray.map(function (colLabel, colIndex) { return (React.createElement(PlaceholderSquare, { width: colWidth, key: colLabel + "#" + colIndex })); }))); })));
    };
    return PlaceholderGrid;
}(PureComponent));
export default PlaceholderGrid;
